import { ChartBarIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import { QuinnCopy } from "../../types";
import type { QuinnArtifact } from "../../utils/artifacts.ts";

type QuinnArtifactCardProps = {
    artifact: QuinnArtifact;
    isOpen: boolean;
    onOpen: () => void;
};

export function QuinnArtifactCard({ artifact, isOpen, onOpen }: QuinnArtifactCardProps) {
    const Icon = artifact.kind === "table" ? TableCellsIcon : ChartBarIcon;
    return (
        <button
            type="button"
            onClick={onOpen}
            className={`my-3 flex w-full items-center gap-3 rounded-xl border px-3.5 py-3 text-left transition-colors ${
                isOpen ? "border-primary/40 bg-primary/5" : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"
            }`}
        >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <Icon className="h-5 w-5" />
            </span>
            <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-gray-900">{artifact.title}</span>
                <span className="block truncate text-xs text-gray-500">{artifact.summary}</span>
            </span>
            <span className="shrink-0 text-xs font-medium text-primary">
                {isOpen ? QuinnCopy.ArtifactOpened : QuinnCopy.OpenArtifact}
            </span>
        </button>
    );
}
